/**
 * The normalized error a failed request throws. It reads like a plain `Error` so existing callers
 * are unaffected, and carries the response status for the ones that need to tell apart a meaningful
 * status — a 404 that means "nothing here" — from a genuine failure.
 */
export class HttpError extends Error {
  readonly status?: number;
  readonly code?: string;

  constructor(message: string, status?: number, code?: string) {
    super(message);
    this.name = 'HttpError';
    this.status = status;
    this.code = code;
  }
}

export function statusOf(error: unknown): number | undefined {
  return error instanceof HttpError ? error.status : undefined;
}
